import type { NodeId } from "~/models/dto";
import { ImmutableMap } from "~/tools/immutable-map";
import type { Record } from "~/tools/record";
import type { RequestStatus } from "~/tools/request-status";

export interface StackPackConfigurationState {
	fields: Record<string, string>;
	stackPacksProvisionStatus?: RequestStatus<Error, true>;
	stackPacksDeprovisionStatus?: RequestStatus<Error, true>;
	stackPackConfirmStatus?: RequestStatus<Error, true>;
}

export interface StackPacksDetailsState {
	configs: ImmutableMap<NodeId, StackPackConfigurationState>;
	config?: StackPackConfigurationState;
}

export const initialStackPackDetailsConfigurationState: StackPackConfigurationState = {
	stackPacksProvisionStatus: undefined,
	stackPacksDeprovisionStatus: undefined,
	stackPackConfirmStatus: undefined,
	fields: {},
};

export const initialStackPackConfigurationState: StackPackConfigurationState = {
	fields: {},
	stackPacksDeprovisionStatus: undefined,
	stackPacksProvisionStatus: undefined,
	stackPackConfirmStatus: undefined,
};

export const initialStackPacksDetailsState: StackPacksDetailsState = {
	configs: ImmutableMap.empty(),
	config: undefined,
};
